var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo, useState } from 'react';
import useWindowSize from '../../customHooks/useWindowWidth';
import { Inline, Stack } from '../../spacing';
import { CarouselWrapper, Dot, DotWrapper, SlideWrapper } from './subcomponents';
const Carousel = (_a) => {
    var { slides } = _a, props = __rest(_a, ["slides"]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const windowWidth = useWindowSize();
    const isMobile = windowWidth.isLessThanTablet;
    let touchStart = 0;
    let touchEnd = 0;
    const handleTouchMove = (event) => {
        const targetTouch = event === null || event === void 0 ? void 0 : event.targetTouches[0];
        if (targetTouch) {
            touchEnd = targetTouch.clientX;
        }
    };
    const handleTouchStart = (event) => {
        const targetTouch = event === null || event === void 0 ? void 0 : event.targetTouches[0];
        if (targetTouch) {
            touchStart = targetTouch.clientX;
        }
    };
    const handleTouchEnd = () => {
        if (touchStart > touchEnd && currentSlide < slides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        }
        else if (touchStart < touchEnd && currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };
    return useMemo(() => (_jsxs(_Fragment, { children: [_jsx(CarouselWrapper, Object.assign({}, props, { onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, onTouchMove: handleTouchMove }, { children: slides.map((slide, index) => {
                    const isActiveSlide = isMobile ? currentSlide === index : true;
                    return (_jsx(SlideWrapper, Object.assign({ isActiveSlide: isActiveSlide, "aria-hidden": !!(isMobile && currentSlide !== index) }, { children: slide }), `slide-${index}`));
                }) })), _jsx(Stack, { size: "small" }), isMobile && (_jsx(DotWrapper, { children: slides.map((_, index) => {
                    const isActiveSlide = currentSlide === index;
                    return (
                    /* eslint-disable-next-line react/no-array-index-key */
                    _jsxs(Fragment, { children: [_jsx(Dot, { onClick: (event) => {
                                    setCurrentSlide(index);
                                    event.preventDefault();
                                }, isActiveSlide: isActiveSlide, "aria-current": isActiveSlide, tabIndex: 0 }), _jsx(Inline, { size: "xsmall" })] }, `dot-${index}`));
                }) }))] })), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentSlide, touchEnd, isMobile]);
};
export default Carousel;
